import { useNavigate } from "react-router-dom";

import { SkinColor } from "../components/SkinColor";
import { usePersonalisationData } from "../context/PersonalisationDataContext";
import { usePersonalisationLeave } from "../context/PersonalisationLeaveContext";

import { HeritageContainer_PATH } from "./HeritageContainer";
import { SkinColorFeedbackContainer_PATH } from "./SkinColorFeedbackContainer";
import { SkinSunContainer_PATH } from "./SkinSunContainer";

export const SkinColorContainer_PATH = "/personalise/skin-type" as const;

export function SkinColorContainer() {
  const navigate = useNavigate();
  const { skinColor, setSkinColorAnswered, skipSkinColor } = usePersonalisationData();
  const { openConfirmLeave } = usePersonalisationLeave();
  return (
    <SkinColor
      progressPercentage={51}
      initialSelectedId={skinColor.state === "answered" ? skinColor.value : null}
      onContinue={(selection) => {
        setSkinColorAnswered(selection);
        navigate(SkinSunContainer_PATH);
      }}
      onSkip={() => {
        skipSkinColor();
        navigate(SkinSunContainer_PATH);
      }}
      onBack={() => navigate(HeritageContainer_PATH)}
      onClose={openConfirmLeave}
    />
  );
}
